import React, {Component} from "react";

import Constants from "../../../constants/constants";

import RoomCardTimer from "./room_card_timer.js";

import {getGameByName} from "../../../modules/game.js";

import RoomCardTooltip from "./room_card_tooltip.js";

import withStaticImages from '../../../services/utils/imageNameRetriever';

class RoomCard extends Component {
    constructor(props) {
        super(props);
        this.gameStates = {
            IDLE: -1,
            WAITING: 1,
            IN_GAME: 2,
            STARTING_SOON: 3
        }

        this.state = {
            game_info: -1,
            show_tooltip: false
        }
        this.gameImages = null;
    }
    

    showTooltip() {
        this.setState({show_tooltip: true});
    }

    hideTooltip() {
        this.setState({show_tooltip: false});
    }

    async componentDidMount() {
        let {room_data, token} = this.props;
        var gameDataResponse = await getGameByName(room_data.game_name, token);
        
        if (gameDataResponse && gameDataResponse.data.success) {
            this.setState({game_info: gameDataResponse.data.game});
        }
    }

    onJoinClick() {
        let {room_data, token} = this.props;
        let port = window.location.port;
        let platformURL = "https://" + window.location.hostname;

        if (port !== "") {
            platformURL += ":" + port;
        }
        platformURL = encodeURIComponent(platformURL);


        window.location = Constants.getPlayContentUrl() + "/play_game?room_code=" + room_data.key + "&auth=" + token + "&purl=" + platformURL;
    }

    render() {
        let {room_data} = this.props;

        let {game_info, show_tooltip} = this.state;
        var info = room_data.info;
        var name = `Join a live ${room_data.game_name} game`;
        var description = `Public ${room_data.game_name} games are always on.`
        var gameName = room_data.game_name;
        var playerCount = info.player_count;
        var roomStatus = info.status;
        let allowJoin = false;
        
        switch (parseInt(roomStatus, 10)) {
            case this.gameStates.WAITING:
                allowJoin = true;
                break;
            case this.gameStates.STARTING_SOON:
                allowJoin = true;
                break;
            default:
                break;
        }       
        if (room_data.is_full) {
            allowJoin = false;            
        }
        var playersText = "players";

        if (playerCount === 1) {
            playersText = "player";
        }
        console.log("online card!");
        
        return (
            <div className='multiplayer_card_container' onMouseEnter={this.showTooltip.bind(this)}
            onMouseLeave={this.hideTooltip.bind(this)}>
                <div className='online_room_card'>
                    <img alt='background_image_multi' className='multiplayer_card_background_image' src={this.props.getImage(`${gameName}.png`)} />
                    {show_tooltip && <RoomCardTooltip game_info={game_info}></RoomCardTooltip>}
                    <div className='room_card_top_label'><span className='live_dot'></span><span className='live_text'>Live</span><span className='room_card_label'>Starting in:</span><RoomCardTimer timer={room_data.timer}/></div>
                    {playerCount > 0 && <div className='online_room_card_player_count'>{playerCount} {playersText} in the room</div>}
                    {allowJoin && <div className='online_room_join' onClick={this.onJoinClick.bind(this)}>JOIN GAME</div>}
                </div>
                <div className='room_card_text'>
                    <div className='room_card_text_title'><i className='fa fa-group multiplayer_sub_icon'></i>{name}</div>
                    <div className='room_card_text_description'>{description}</div>
                </div>
            </div>
        )
    }
}

export default withStaticImages('multiplayer_card_images',RoomCard);


// WEBPACK FOOTER //
// ./src/components/containers/online-room-list/room_card.js